// extracted by mini-css-extract-plugin
export default {"recos":"_4-z","productCardOverride":"a5-z","rowHasBadge":"b5-z"};